import {
  // SET_FINANCE_MESSAGE_LIST,
  SET_INVOICE_EXPORTING,
  SET_STATISTICS_SEARCHING,
} from './mutation-types'
import api from '@/api'
import files from 'file-saver'
import {getHeaderName} from '@/utils'

const state = {
  // list: [],
  exporting: false,
  searching: false,
}

const mutations = {
  // [SET_FINANCE_MESSAGE_LIST] (state, payload) {
  //   state.list = payload
  // },
  [SET_INVOICE_EXPORTING] (state, payload) {
    state.exporting = payload
  },
  [SET_STATISTICS_SEARCHING] (state, payload) {
    state.searching = payload
  },
}

const actions = {
  // 发票列表
  // eslint-disable-next-line
  async getInvoiceList ({commit}, payload) {
    commit(SET_STATISTICS_SEARCHING, true)
    const result = await api.financeApi.getReceipts(payload)
    commit(SET_STATISTICS_SEARCHING, false)
    return result
  },
  async exportInvoiceList ({commit}, payload) {
    commit(SET_INVOICE_EXPORTING, true)
    const {data, headers} = await api.financeApi.exportInvoiceList(payload)
    commit(SET_INVOICE_EXPORTING, false)
    if (!headers['content-disposition']) {
      window.vm.$message({
        message: window.vm.$t(`api_700`),
        type: 'error',
      })
      return
    }
    const fileName = getHeaderName(headers)
    const blob = new Blob([data], { type: 'application/vnd.ms-excel' })
    files.saveAs(blob, fileName)
  },
  // 添加发票拒绝理由
  async rejectAdd ({commit}, payload) {
    const {code, message} = await api.financeApi.changeInvoicStatus(payload)
    return {code, message}
  },
  // 添加发票邮寄信息
  async addMailInfo ({commit}, payload) {
    const {code, message} = await api.financeApi.changeInvoicStatus(payload)
    return {code, message}
  },
   // 发票确认收款
  async resolvePay ({commit}, payload) {
    const {code, message} = await api.financeApi.confirmInvoice(payload)
    return {code, message}
  },
  // 用户操作
  async setStatus ({commit, state}, payload) {
    const {code, message} = await api.financeApi.changeInvoicStatus(payload)
    return {code, message}
  },
  // 更新备注
  async updateReceipt ({commit, state}, payload) {
    const {code, message} = await api.financeApi.updateReceipt(payload)
    return {code, message}
  },
  // 更新发票状态备注
  async updateFinanceRemark ({commit, state}, payload) {
    const {code, message} = await api.financeApi.updateFinanceRemark(payload)
    return {code, message}
  },
}
export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
